import React from "react";
import CustomBigCard from "../custom/CustomBigCard";
import Reservations from "./Reservations";

const Meta = ({ meta, period, property, bookings, onReady }) => {
    React.useEffect(() => {
        if (onReady) {
            console.log('Meta: calling onReady');
            setTimeout(() => onReady(), 50);
        }
    }, [meta, bookings, onReady]);
    const hasValidData = meta && meta.data && meta.data.some(item => 
        item && (item.data_0 > 0 || item.data_1 > 0 || item.data_2 > 0 || item.data_3 > 0)
    );

    if (!hasValidData) {
        return (
            <div className="analytics-card meta-empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="#3B61E1"/>
                </svg>
                <div className="meta-empty-header">
                    <h3>Aucune réservation Meta détectée</h3>
                </div>
                <div className="meta-empty-content">
                    <p>
                        Aucune réservation provenant des Métas n'a été enregistrée pour cette période. Si vous pensez que c'est une erreur, contactez notre équipe de support.
                    </p>
                </div>
                <a href="mailto:support@altelis.com" className="meta-support-button">
                    Contacter le support
                </a>
            </div>
        );
    }

    return (
        <div className="ads-container">
            <div className="ads-row">
                <CustomBigCard
                    data_first={meta.data[0]}
                    data_second={meta.data[1]}
                    data_third={meta.data[5]}
                    period={period}
                    tooltip={meta.data[0]?.tooltip || false}
                />
                <CustomBigCard
                    data_first={meta.data[4]}
                    data_second={meta.data[2]}
                    data_third={meta.data[3]}
                    period={period}
                    tooltip={meta.data[0]?.tooltip || false}
                    isInvert
                />
            </div>
            <Reservations data={bookings || []} period={period} />
        </div>
    );
};

export default Meta;
